<template>
  <BackButtonComponent
    v-if="haveBrowserHistory"
    @goBack="onGoBack"
  />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import BackButtonComponent from "@/components/ControlButtons/BackButtonComponent.vue"

import { stepBackInBrowserHistory } from "@/utils/helpers"

@Options({
  name: "BackByRoute",
  components: {
    BackButtonComponent
  }
})
export default class BackByRoute extends Vue {
  @Prop({ default: true }) readonly canGoBack: boolean

  haveBrowserHistory = false

  mounted() {
    if (this.$route.params.accountId || this.$route.name === "Error") {
      this.haveBrowserHistory = stepBackInBrowserHistory(this.$route)
    }
  }

  async onGoBack() {
    if (!this.canGoBack || this.$wait.is("goToPreviousPage")) {
      return
    }
    this.$wait.start("goToPreviousPage")
    await this.$router.go(-1)
    this.$wait.end("goToPreviousPage")
  }
}
</script>
